<template>
  <div class="top3-example pt-3">

    <div class="row gx-2 gy-2 justify-content-center">

      <div class="col-12 col-md-6 col-lg-4">
        
            <div class="card h-100 is-flippable" :class="{ 'is-flipped': isFlippedTop(index) }">
              <div class="card-front">
                <div class="ribbon-wrapper">
                  <div class="ribbon">Kleinster Preis</div>
                </div>
                <div class="cardHead my-2">
                  <h5 class="card-title text-start mt-3 mx-5">
                    {{ this.lowestPrice.amazonNamenSuche }}
                  </h5>
                </div>
                <div class="img_center">
                  <section id="splide-top-1" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.lowestPrice.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsLowestPrice()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-1" class="splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.lowestPrice.bild_url" alt="Product Image" />

                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsLowestPrice()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-1"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.horizontalPixel }}x{{ lowestPrice.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ lowestPrice.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <button class="datasheet-button" @click="flipCardTop(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ lowestPrice.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ lowestPrice.preisAmazonNeu }}€</span><br />
                        </div>
                        <a :href="this.lowestPrice.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="lowestPrice" />
                  <button class="datasheet-button" @click="flipCardTop(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
            </div>
          
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card h-100 is-flippable" :class="{ 'is-flipped': isFlippedTop2(index) }">
              <div class="card-front">
                <div class="ribbon-wrapper">
                  <!-- You can change the text inside the ribbon -->
                  <div class="ribbon">Höchste Bewertung</div>
                </div>
                <div class="cardHead my-2">
                <h5 class="card-title text-start mt-3 mx-5">
                    {{ bestRating.amazonNamenSuche }}
                  </h5>
                  </div>
                <div class="img_center">
                  <section id="splide-top-2" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.bestRating.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestRating()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-2" class="splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="this.bestRating.bild_url" alt="Product Image" />

                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestRating()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-2"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.horizontalPixel }}x{{ bestRating.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestRating.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button class="datasheet-button" @click="flipCardTop3(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ bestRating.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ bestRating.preisAmazonNeu }}€</span><br />
                        </div>
                        <a :href="this.bestRating.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="bestRating" />
                  <button class="datasheet-button" @click="flipCardTop3(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card h-100 is-flippable" :class="{ 'is-flipped': isFlippedTop3(index) }">


              <div class="card-front">
                <div class="ribbon-wrapper">
                  <!-- You can change the text inside the ribbon -->
                  <div class="ribbon">PL-Sieger</div>
                </div>

               <div class="cardHead my-2">
                <h5 class="card-title text-start mt-3 mx-2">
                    {{ this.bestAmazon.amazonNamenSuche }}
                  </h5>
                  </div>
                <div class="img_center">
                  <section id="splide-top-3" class="splide" aria-label="Beautiful Images">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="bestAmazon.bild_url" alt="Product Image" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestAmazon()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Product Image" />
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section id="thumbnail-splide-top-3" class="splide" aria-label="The carousel with thumbnails.">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img :src="bestAmazon.bild_url" alt="Thumbnail" />
                        </li>
                        <li v-for="(imageUrl, index) in getImageUrlsBestAmazon()" :key="index" class="splide__slide">
                          <img :src="imageUrl" alt="Thumbnail" />
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>

                <div class="card-body">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas id="chart-top-3"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.paneltyp }} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.horizontalPixel }}x{{ bestAmazon.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ bestAmazon.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button class="datasheet-button" @click="flipCardTop4(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ bestAmazon.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ bestAmazon.preisAmazonNeu }}€</span><br />
                        </div>
                        <a :href="this.bestAmazon.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod :product="bestAmazon" />
                  <button class="datasheet-button" @click="flipCardTop4(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i> Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
        
      </div>
    </div>
  
</template>


<script>
import DatenblattMod from "./DatenblattMod.vue";
import TopThreeDatenblattMod from "./TopThreeDatenblattMod.vue";
import Feedback from "./Feedback.vue";

export default {
  components: {
    DatenblattMod,
    TopThreeDatenblattMod,
    Feedback
  },
  data() {
    return {
      openIndex: 0,
      flippedCards2: [],
      flippedCards3: [],
      flippedCards4: [],
    }
  },
  props: {
    lowestPrice:    { type: Object,  required: true },
    bestRating:     { type: Object,  required: true },
    bestAmazon:     { type: Object,  required: true },
    detailsContent: { type: Array,   default: () => [] },
    explanations:   { type: Array,   default: () => [] },
    example:        { type: Boolean, default: false }   // ← hier
  },
  methods: {

    flipCardTop(index) {
      const cardIndex = this.flippedCards2.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards2.push(index);
      } else {
        this.flippedCards2.splice(cardIndex, 1);
      }
    },

    flipCardTop3(index) {
      const cardIndex = this.flippedCards3.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards3.push(index);
      } else {
        this.flippedCards3.splice(cardIndex, 1);
      }
    },

    flipCardTop4(index) {
      const cardIndex = this.flippedCards4.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards4.push(index);
      } else {
        this.flippedCards4.splice(cardIndex, 1);
      }
    },

    isFlippedTop(index) {
      return this.flippedCards2.includes(index);
    },

    isFlippedTop2(index) {
      return this.flippedCards3.includes(index);
    },

    isFlippedTop3(index) {
      return this.flippedCards4.includes(index);
    },

    getImageUrlsLowestPrice() {
      return this.lowestPrice.picVariants.split(';');
    },

    getImageUrlsBestRating() {

      return this.bestRating.picVariants.split(';');
    },

    getImageUrlsBestAmazon() {

      return this.bestAmazon.picVariants.split(';');
    },


    handleSummaryClick(index) {

      this.openIndex = this.openIndex === index ? -1 : index;

    },
    renderChartTop(ctx, prod) {

      const width = window.innerWidth;

      let barThickness, borderWidth, borderRadius;

      if (width >= 2560) {
        barThickness = 50;
        borderWidth = 0.6;
        borderRadius = 5;
      } else if (width >= 1920) {
        barThickness = 38;
        borderWidth = 0.6;
        borderRadius = 5;
      } else {
        barThickness = 38;
        borderWidth = 0.6;
        borderRadius = 5;
      }

      const drawCategoryLabels = {
        id: 'drawCategoryLabels',
        afterDatasetsDraw(chart) {
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = '16px ${bsSans}';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'left';
          ctx.textBaseline = 'bottom';

          // Meta für das Hintergrund-Dataset (Index 0)
          const meta0 = chart.getDatasetMeta(0);

          chart.data.labels.forEach((label, i) => {
            const bar = meta0.data[i];
            // X: exakt linker Balkenanfang
            const x = chart.chartArea.left;   // +10 px Puffer, damit der Text nicht direkt am Rand klebt
            // Y: ein paar Pixel oberhalb der Balkenmitte
            const y = bar.y - (bar.height / 2);
            ctx.fillText(label, x, y);
          });

          ctx.restore();
        }
      };

      // 2) Chart-Instanz
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Gaming', 'Office', 'Editing'],
          datasets: [
            {
              // Dataset 0: 100%-Hintergrund (ohne datalabels)
              data: [10, 10, 10],
              backgroundColor: 'rgba(252,245,235,0.5)',
              barThickness: 25,
              borderRadius: 25,
              borderColor: '#333',
              borderWidth: 1,
              borderSkipped: false,
              order: 1,
              grouped: false,
              categoryPercentage: 1,
              barPercentage: 1,

            },
            {
              // Dataset 1: Prozentbalken + DataLabels ganz normal rechts
              data: [
                +((prod.pcGamingVal / 10).toFixed(1)),
                +((prod.officeVal / 10).toFixed(1)),
                +((prod.editingVal / 10).toFixed(1))
              ],
              backgroundColor: [
                'rgba(255,0,0,0.8)',
                'rgba(0,64,255,0.8)',
                'rgba(255,252,0,0.8)'
              ],
              borderColor: '#333',
              borderWidth: 1,
              barThickness: 25,
              borderRadius: 10,
              borderSkipped: false,
              order: 2,
              grouped: false,
              categoryPercentage: 1,
              barPercentage: 1,
              datalabels: {
                display: true,
                //formatter: v => v + ' %',
                anchor: 'center',
                align: 'right',
                color: '#333',
                font: { size: 18 },
                clamp: false
              }
            }
          ]
        },

        plugins: [ChartDataLabels, drawCategoryLabels],

        options: {
          responsive: true,           // Chart passt sich der Größe des Canvas-Containers an
          maintainAspectRatio: false, // erlaubt es, die Höhe unabhängig von der Breite zu steuern
          layout: { padding: { left: 25, right: 25, top: 5 } },
          indexAxis: 'y',
          plugins: {
            legend: { display: false },
            tooltip: { filter: item => item.datasetIndex === 1 },
            datalabels: {
              display: ctx => ctx.datasetIndex === 1,
              anchor: 'center',
              align: 'right',
              color: '#333',
              font: { size: 18 },
              clamp: false
            }
          },
          scales: {
            y: { display: false },
            x: { display: false, min: 0, max: 10 }
          }
        }
      });
    }
  },
  mounted() {
    const charttop1 = 'chart-top-1';
    const ctxtop1 = document.getElementById(charttop1).getContext('2d');

    const charttop2 = 'chart-top-2';
    const ctxtop2 = document.getElementById(charttop2).getContext('2d');

    const charttop3 = 'chart-top-3';
    const ctxtop3 = document.getElementById(charttop3).getContext('2d');

    this.renderChartTop(ctxtop1, this.lowestPrice);
    this.renderChartTop(ctxtop2, this.bestRating);
    this.renderChartTop(ctxtop3, this.bestAmazon);


    const mainSplideTop1 = 'splide-top-1';
    const mainSplideElementTop1 = document.getElementById(mainSplideTop1);

    const thumbnailSplideTop1 = 'thumbnail-splide-top-1';
    const thumbnailSplideElementTop1 = document.getElementById(thumbnailSplideTop1);

    const mainSplideTop2 = 'splide-top-2';
    const mainSplideElementTop2 = document.getElementById(mainSplideTop2);

    const thumbnailSplideTop2 = 'thumbnail-splide-top-2';
    const thumbnailSplideElementTop2 = document.getElementById(thumbnailSplideTop2);

    const mainSplideTop3 = 'splide-top-3';
    const mainSplideElementTop3 = document.getElementById(mainSplideTop3);

    const thumbnailSplideTop3 = 'thumbnail-splide-top-3';
    const thumbnailSplideElementTop3 = document.getElementById(thumbnailSplideTop3);

    const mainSplide1 = new Splide(mainSplideElementTop1, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails1 = new Splide(thumbnailSplideElementTop1, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    const mainSplide2 = new Splide(mainSplideElementTop2, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails2 = new Splide(thumbnailSplideElementTop2, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    const mainSplide3 = new Splide(mainSplideElementTop3, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails3 = new Splide(thumbnailSplideElementTop3, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    mainSplide1.sync(thumbnails1);
    mainSplide1.mount();
    thumbnails1.mount();

    mainSplide2.sync(thumbnails2);
    mainSplide2.mount();
    thumbnails2.mount();

    mainSplide3.sync(thumbnails3);
    mainSplide3.mount();
    thumbnails3.mount();
  }
};
</script>

<style>
.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  position: relative;
  /* Wichtig für die Positionierung von card-back */
  display: flex;

}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background-color: #fff;
  /* Hintergrund hier setzen */
  border-radius: 10px;
  /* Wichtig: Radius der Elternkarte übernehmen */

  /* Stile, die für das Ribbon notwendig sind */
  position: relative;
  overflow: hidden;
}

.card-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background-color: #fff;
  /* Hintergrund hier setzen */
  border-radius: 10px;
  /* Wichtig: Radius der Elternkarte übernehmen */
  transform: rotateY(180deg);
}




.label-data-front {
  color: #999
}

.btn13 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

.icon-margin-right {
  margin-right: 8px;
}

.highlights {
  color: var(--default-black, #222);
  background: #b9d1ff;
  position: relative;
  border: 1px solid #222222;
  border-left: none;
  font-weight: 500;
  margin-bottom: 0;
}

.specs {
  display: flex;
  flex-wrap: wrap;
}

.spec-item {
  flex: 1 0 200px;
  margin: 10px;
  border: 1px solid #222;
  background: #121212;
  border-radius: 12px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.spec-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.spec-item::before {
  content: "";
  position: absolute;
  top: -75px;
  right: -75px;
  width: 128px;
  height: 128px;
  background-color: #f9b23478;
  border-radius: 50%;
}

.icon-black {
  color: black !important;
}

/* Unterschiedliche Farben je nach Elementposition */
.spec-item:nth-child(2n)::before {
  background-color: #3ecd5e5e;
}

.spec-item:nth-child(3n)::before {
  background-color: #e4400261;
}

.spec-item:nth-child(4n)::before {
  background-color: #952aff66;
}

.spec-item:nth-child(5n)::before {
  background-color: #cd3e9462;
}

.spec-item:nth-child(6n)::before {
  background-color: #4c49ea83;
}

/* Stellt sicher, dass der Text über dem Kreis sichtbar bleibt */
.spec-item>* {
  position: relative;
  z-index: 2;
  color: #fff;
}

.ribbon-wrapper {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
  /* Stellt sicher, dass das Ribbon über anderem Inhalt liegt */
}

.ribbon {
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #040404;

  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: relative;
  padding: 7px 0;
  left: -5px;
  top: 45px;
  width: 200px;

  /* Starke rote Farbe */
  background-color: #296fe84f;

  /* Alternative Farben:
     Starkes Blau: #3498db
     Starkes Grün: #2ecc71
     Starkes Orange: #f39c12
  */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.top3-example .card {
  /* max-width: 300px; niemals breiter als 300px */
  margin: 0 auto;    /* zentriert in der Spalte */
}

/* !!! Das muss neu rein wenn startseite gemacht wird!!! da sonst wohl rechts iregdnwie platz ist /*
/* Smartphones (max-width: 576px) */
@media (max-width: 576px) {
  .row {
    overflow-x: hidden;
  }
}

/* Tablets (bis max-width: 992px) */
@media (max-width: 992px) {
  .row {
    overflow-x: hidden;
  }
}


</style>